module.exports = __webpack_public_path__ + "static/media/sponsorSens.f351e27b.jpg";